import { getSellerPropsForLogs } from '@/monitoring/logger'
import { isLocalEnvironment, isProductionEnvironment } from '@/resources/utils'
import { generateTraceId } from '@/trace'
import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

const SITE = 'datadoghq.com'

export const initDatadog = () => {
  if (isLocalEnvironment) return

  const environment = isProductionEnvironment ? 'prod' : 'dev'

  datadogRum.init({
    applicationId: process.env.DATADOG_APP_ID ?? '',
    clientToken: process.env.DATADOG_CLIENT_TOKEN ?? '',
    site: SITE,
    service: process.env.DATADOG_SERVICE,
    env: environment,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
  })

  datadogRum.startSessionReplayRecording()

  datadogLogs.init({
    clientToken: process.env.DATADOG_CLIENT_TOKEN ?? '',
    site: SITE,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    service: process.env.DATADOG_SERVICE,
    env: environment,
    beforeSend: log => {
      log.seller = getSellerPropsForLogs()
      log.trace_id = generateTraceId()
      return true
    },
  })
}

export const updateDatadogUser = () => {
  const sellerData = getSellerPropsForLogs()
  const user = { id: String(sellerData.poc_id) }
  datadogRum.setUser(user)
}

export const clearDatadogUser = () => {
  datadogRum.setUser({ id: 'no_data' })
}
